var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "timesheet-layout d-flex flex-row w-100 h-100 bg-white",
      staticStyle: { "min-height": "0" }
    },
    [
      _c(
        "div",
        {
          staticClass: "d-flex flex-column flex-grow-1 h-100 overflow-hidden",
          staticStyle: { "min-width": "0" }
        },
        [
          !_vm.readonly && _vm.workers.length > 0
            ? _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-between mb-3 flex-shrink-0 px-2"
                },
                [
                  _c("div", { staticClass: "d-flex align-items-center" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.currentMonth,
                            expression: "currentMonth"
                          }
                        ],
                        staticClass: "custom-select-filters mr-2",
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.currentMonth = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      _vm._l(_vm.availableMonths, function(month) {
                        return _c(
                          "option",
                          {
                            key: month.index,
                            domProps: { value: month.index }
                          },
                          [_vm._v(_vm._s(month.name))]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.currentYear,
                            expression: "currentYear"
                          }
                        ],
                        staticClass: "custom-select-filters mr-2",
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.currentYear = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      _vm._l(_vm.availableYears, function(year) {
                        return _c(
                          "option",
                          { key: year, domProps: { value: year } },
                          [_vm._v(_vm._s(year))]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex" }, [
                      _c("input", {
                        staticClass: "d-none",
                        attrs: { type: "radio", id: "calc-total" },
                        domProps: {
                          checked:
                            _vm.calcMode === "total" && _vm.showCalculations
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "mb-0 cursor-pointer",
                          class: [
                            _vm.calcMode === "total" && _vm.showCalculations
                              ? "custom-btn-primary"
                              : "custom-btn-secondary"
                          ],
                          staticStyle: {
                            "border-top-right-radius": "0 !important",
                            "border-bottom-right-radius": "0 !important"
                          },
                          on: { click: _vm.toggleTotalCalc }
                        },
                        [_vm._v("\n            Расчёты\n          ")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        staticClass: "d-none",
                        attrs: { type: "radio" },
                        domProps: { checked: _vm.calcMode === "individual" }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "mb-0 cursor-pointer",
                          class: [
                            _vm.calcMode === "individual"
                              ? "custom-btn-primary"
                              : "custom-btn-secondary"
                          ],
                          staticStyle: {
                            "border-top-left-radius": "0 !important",
                            "border-bottom-left-radius": "0 !important",
                            "margin-left": "-1px !important"
                          },
                          attrs: { id: "calc-individual" },
                          on: { click: _vm.toggleIndividualCalc }
                        },
                        [_vm._v("\n            Отдельные расчёты\n          ")]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex align-items-center" },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "custom-btn-secondary mr-2",
                          class: {
                            "is-btn-flashing": _vm.flashState.assignBtn,
                            "active-mode": _vm.activeMode === "assign"
                          },
                          attrs: { id: "assign-btn", type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.toggleMode("assign")
                            }
                          }
                        },
                        [
                          _c("v-icon", {
                            attrs: { name: "buttons/plus", size: 16 }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tooltip",
                        {
                          attrs: {
                            target: "assign-btn",
                            triggers: "hover",
                            "custom-class": "custom-tooltip",
                            noninteractive: ""
                          }
                        },
                        [_vm._v("\n          Назначить\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "custom-btn-secondary mr-2 text-danger",
                          class: {
                            "is-btn-flashing": _vm.flashState.removeBtn,
                            "active-mode": _vm.activeMode === "remove"
                          },
                          attrs: { id: "remove-btn", type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.toggleMode("remove")
                            }
                          }
                        },
                        [
                          _c("v-icon", {
                            attrs: { name: "buttons/trash", size: 16 }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tooltip",
                        {
                          attrs: {
                            target: "remove-btn",
                            triggers: "hover",
                            "custom-class": "custom-tooltip",
                            noninteractive: ""
                          }
                        },
                        [_vm._v("\n          Удалить\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "custom-btn-secondary mr-2",
                          class: {
                            "is-btn-flashing": _vm.flashState.planBtn,
                            "active-mode": _vm.activeMode === "plan"
                          },
                          attrs: { id: "planning-btn", type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.toggleMode("plan")
                            }
                          }
                        },
                        [
                          _c("v-icon", {
                            attrs: { name: "buttons/calendar", size: 16 }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tooltip",
                        {
                          attrs: {
                            target: "planning-btn",
                            triggers: "hover",
                            "custom-class": "custom-tooltip",
                            noninteractive: ""
                          }
                        },
                        [_vm._v("\n          Запланировать\n        ")]
                      )
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex-grow-1 position-relative mx-2 mb-2",
              staticStyle: { "min-height": "0" }
            },
            [
              _c(
                "div",
                {
                  ref: "scrollContainer",
                  staticClass:
                    "timesheet-container position-absolute w-100 h-100 hardware-accel",
                  class: {
                    "is-planning": _vm.activeMode === "plan",
                    "scroll-locked": _vm.scrollLocked,
                    "flash-targets-assign":
                      _vm.flashState.table && _vm.activeMode === "assign",
                    "flash-targets-remove":
                      _vm.flashState.table && _vm.activeMode === "remove",
                    "flash-targets-plan":
                      _vm.flashState.table && _vm.activeMode === "plan"
                  },
                  on: {
                    contextmenu: function($event) {
                      $event.preventDefault()
                      return _vm.clearHighlight.apply(null, arguments)
                    }
                  }
                },
                [
                  _vm.workers.length > 0
                    ? _c(
                        "div",
                        { staticClass: "timesheet-grid d-flex w-100 h-100" },
                        [
                          _c("div", { staticClass: "timesheet-fixed-panel" }, [
                            _vm._m(0),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                ref: "fixedBody",
                                staticClass: "timesheet-body-fixed"
                              },
                              _vm._l(_vm.workers, function(worker) {
                                return _c(
                                  "div",
                                  {
                                    key: worker.id,
                                    staticClass: "timesheet-row"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "worker-col-name text-truncate",
                                        attrs: { title: worker.name }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(worker.name) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "price-col-cell" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model.number",
                                              value:
                                                _vm.workerPrices[worker.id],
                                              expression:
                                                "workerPrices[worker.id]",
                                              modifiers: { number: true }
                                            }
                                          ],
                                          staticClass: "price-cell-input",
                                          attrs: {
                                            type: "number",
                                            min: 0,
                                            placeholder: "0",
                                            readonly: _vm.readonly
                                          },
                                          domProps: {
                                            value: _vm.workerPrices[worker.id]
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.workerPrices,
                                                worker.id,
                                                _vm._n($event.target.value)
                                              )
                                            },
                                            blur: function($event) {
                                              return _vm.$forceUpdate()
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              ref: "scrollablePanel",
                              staticClass:
                                "timesheet-scrollable-panel flex-grow-1",
                              on: { scroll: _vm.syncScroll }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "timesheet-header-scrollable" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "timesheet-row mb-1" },
                                    _vm._l(_vm.daysInCurrentMonth, function(
                                      day
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: "count-" + day.dateString,
                                          staticClass: "day-counter-cell"
                                        },
                                        [
                                          _vm.columnWorkerCounts[
                                            day.dateString
                                          ] > 0
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.columnWorkerCounts[
                                                        day.dateString
                                                      ]
                                                    ) +
                                                    " чел.\n                  "
                                                )
                                              ])
                                            : _vm._e()
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "timesheet-row" },
                                    _vm._l(_vm.daysInCurrentMonth, function(
                                      day,
                                      dIndex
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: day.dateString,
                                          staticClass: "day-header-cell",
                                          class: {
                                            "is-weekend": day.isWeekend,
                                            "is-today": day.isToday,
                                            "is-col-hovered":
                                              _vm.hoveredDayIndex === dIndex,
                                            "is-clickable":
                                              !_vm.readonly &&
                                              !_vm.planningMode,
                                            "flash-calc-target":
                                              _vm.calcMode === "individual" &&
                                              _vm.groupedPlannedWorkers[
                                                day.dateString
                                              ]
                                          },
                                          attrs: {
                                            id:
                                              day.dayNumber === 5
                                                ? "target-cell-5"
                                                : null
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.handleHeaderClick(
                                                day.dateString
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "day-name" },
                                            [_vm._v(_vm._s(day.dayName))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "day-number" },
                                            [_vm._v(_vm._s(day.dayNumber))]
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "timesheet-body-scrollable",
                                  on: {
                                    mouseleave: function($event) {
                                      _vm.hoveredDayIndex = null
                                    }
                                  }
                                },
                                _vm._l(_vm.workers, function(worker, wIndex) {
                                  return _c(
                                    "div",
                                    {
                                      key: worker.id,
                                      staticClass: "timesheet-row"
                                    },
                                    _vm._l(_vm.daysInCurrentMonth, function(
                                      day,
                                      dIndex
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: day.dateString,
                                          staticClass: "day-cell",
                                          class: {
                                            "is-selected": _vm.selectedCells.has(
                                              worker.id + "_" + day.dateString
                                            ),
                                            "is-highlighted":
                                              _vm.highlightedCells[
                                                worker.id + "_" + day.dateString
                                              ],
                                            "is-readonly": _vm.readonly,
                                            "is-disabled":
                                              _vm.activeMode === "plan" &&
                                              !_vm.selectedCells.has(
                                                worker.id + "_" + day.dateString
                                              ),
                                            "is-col-hovered":
                                              _vm.hoveredDayIndex === dIndex,
                                            "is-dragged":
                                              _vm.activeSelectionBounds &&
                                              wIndex >=
                                                _vm.activeSelectionBounds
                                                  .minR &&
                                              wIndex <=
                                                _vm.activeSelectionBounds
                                                  .maxR &&
                                              dIndex >=
                                                _vm.activeSelectionBounds
                                                  .minC &&
                                              dIndex <=
                                                _vm.activeSelectionBounds.maxC
                                          },
                                          attrs: {
                                            id:
                                              day.dayNumber === 1
                                                ? "target-cell-1"
                                                : "cell-" +
                                                  worker.id +
                                                  "_" +
                                                  day.dateString
                                          },
                                          on: {
                                            mouseenter: function($event) {
                                              return _vm.onMouseEnter(
                                                wIndex,
                                                dIndex
                                              )
                                            },
                                            mousedown: function($event) {
                                              $event.preventDefault()
                                              return _vm.onMouseDown(
                                                wIndex,
                                                dIndex
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm.taskWorkerCells[
                                            worker.id + "_" + day.dateString
                                          ]
                                            ? _c("v-icon", {
                                                staticClass: "text-white",
                                                attrs: {
                                                  name: "buttons/check",
                                                  size: 11
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    }),
                                    0
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        ]
                      )
                    : !_vm.readonly
                    ? _c(
                        "div",
                        { staticClass: "empty-state-container mt-5" },
                        [
                          _c("v-icon", {
                            attrs: { name: "navbar/empty_table", size: 90 }
                          }),
                          _vm._v(" "),
                          _c("h5", [
                            _vm._v("Нет исполнителей для отображения.")
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "Сначала добавьте исполнителей, прежде чем перейти к табелю"
                            )
                          ])
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "p-3 text-muted text-center w-100" },
                        [
                          _c("v-icon", {
                            attrs: { name: "navbar/empty_table", size: 90 }
                          }),
                          _vm._v(
                            "\n          Нет исполнителей для отображения\n        "
                          )
                        ],
                        1
                      )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "layout-slide-up" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showCalculations,
                    expression: "showCalculations"
                  }
                ],
                staticClass: "calculations-panel flex-shrink-0 px-3"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "text-muted text-small border-bottom font-weight-bold mb-1 pb-1"
                  },
                  [
                    _vm.calcMode === "total"
                      ? _c("span", [
                          _vm._v(
                            "Сводные расчёты по всем заявкам (" +
                              _vm._s(
                                Object.keys(_vm.groupedPlannedWorkers).length
                              ) +
                              ")"
                          )
                        ])
                      : _c("span", [
                          _vm._v("Расчёты за: " + _vm._s(_vm.activeCalcDate))
                        ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "row text-small pb-4" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-4 d-flex flex-column gap-2 border-right"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _c("span", { staticClass: "text-muted" }, [
                            _vm._v("Стоимость за ед.:")
                          ]),
                          _vm._v(" "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.priceFormat(_vm.summaryTotals.payment_first)
                              )
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _c(
                            "span",
                            { staticClass: "text-muted" },
                            [
                              _vm._v(
                                "\n                Кол-во\n                "
                              ),
                              _vm.locationWorks.length
                                ? [
                                    _vm._v(
                                      "\n                  (" +
                                        _vm._s(
                                          _vm.getUnitByCode(
                                            _vm.locationWorks[0].unit_code
                                          ).shortName
                                        ) +
                                        "):\n                "
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.priceFormat(_vm.summaryTotals.total_hours)
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-4 d-flex flex-column gap-2 border-right"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _c("span", { staticClass: "text-muted" }, [
                            _vm._v("Исполнителям:")
                          ]),
                          _vm._v(" "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.priceFormat(
                                  _vm.summaryTotals.total_worker_price
                                )
                              )
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-center"
                        },
                        [
                          _c("span", { staticClass: "text-muted" }, [
                            _vm._v(
                              "\n                С учетом коммиссии СМЗ\n                "
                            ),
                            _c("small", [
                              _vm._v(
                                "(" + _vm._s(_vm.summaryTotals.smz_cost) + "%)"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.priceFormat(
                                  _vm.summaryTotals
                                    .total_worker_price_with_comiss
                                )
                              )
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-center"
                        },
                        [
                          _c("span", { staticClass: "text-muted" }, [
                            _vm._v("Сумма с заказчика:")
                          ]),
                          _vm._v(" "),
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.priceFormat(_vm.summaryTotals.total_price)
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-4 d-flex flex-column gap-2" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between align-items-center"
                      },
                      [
                        _c("span", { staticClass: "text-muted" }, [
                          _vm._v(
                            "\n                Маржинальность\n                "
                          ),
                          _c("small", [_vm._v("(без учета расходов)")])
                        ]),
                        _vm._v(" "),
                        _c(
                          "strong",
                          {
                            staticClass: "text-nowrap",
                            class:
                              _vm.summaryTotals.marginality > 0
                                ? "text-success"
                                : "text-danger"
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.summaryTotals.marginality) +
                                " %\n              "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-between" },
                      [
                        _c("span", { staticClass: "text-muted" }, [
                          _vm._v("Дельта:")
                        ]),
                        _vm._v(" "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.priceFormat(_vm.summaryTotals.total_delta)
                            )
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-between" },
                      [
                        _c("span", { staticClass: "text-muted" }, [
                          _vm._v("Менеджеру:")
                        ]),
                        _vm._v(" "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.priceFormat(_vm.summaryTotals.total_manager)
                            )
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between align-items-center"
                      },
                      [
                        _c("span", { staticClass: "text-muted" }, [
                          _vm._v(
                            "\n                Руководителю\n                "
                          ),
                          _c("small", [_vm._v("(без учета расходов)")])
                        ]),
                        _vm._v(" "),
                        _c("strong", { staticClass: "text-nowrap" }, [
                          _vm._v(
                            _vm._s(
                              _vm.priceFormat(_vm.summaryTotals.total_project)
                            )
                          )
                        ])
                      ]
                    )
                  ])
                ])
              ]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "layout-slide-right" } }, [
        _vm.isPlaningSidebarOpen
          ? _c(
              "div",
              {
                staticClass:
                  "planning-sidebar h-100 flex-shrink-0 d-flex flex-column px-2 pt-2"
              },
              [
                _c(
                  "b-card",
                  { staticClass: "custom-card" },
                  [
                    _c(
                      "b-tabs",
                      {
                        staticClass:
                          "custom-tabs normal-tabs flex-grow-1 d-flex flex-column",
                        staticStyle: { "min-height": "0" },
                        attrs: { id: "planning-tabs" }
                      },
                      [
                        _c(
                          "b-tab",
                          { attrs: { title: "Работы", active: "" } },
                          [
                            _c("b-card", { staticClass: "custom-card my-2" }, [
                              _c(
                                "div",
                                { staticClass: "w-100 d-flex flex-column" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "w-100 mb-2",
                                      attrs: { label: "Время начала" }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: { type: "time" },
                                        model: {
                                          value: _vm.workerItems.start_time,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.workerItems,
                                              "start_time",
                                              $$v
                                            )
                                          },
                                          expression: "workerItems.start_time"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.activePlanCells.length <= 1
                                    ? _c(
                                        "b-form-group",
                                        {
                                          staticClass: "w-100 mb-2",
                                          attrs: { label: "Дата окончания" }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: { type: "date" },
                                            model: {
                                              value: _vm.workerItems.end_date,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.workerItems,
                                                  "end_date",
                                                  $$v
                                                )
                                              },
                                              expression: "workerItems.end_date"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "w-100",
                                      attrs: { label: "Время окончания" }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: { type: "time" },
                                        model: {
                                          value: _vm.workerItems.end_time,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.workerItems,
                                              "end_time",
                                              $$v
                                            )
                                          },
                                          expression: "workerItems.end_time"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-card",
                              { staticClass: "custom-card mt-2" },
                              [
                                _vm._l(_vm.locationWorks, function(
                                  work,
                                  index
                                ) {
                                  return _c(
                                    "div",
                                    { key: index },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          staticClass: "mb-2",
                                          attrs: { label: "Вид работ" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "position-relative"
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  value: work.work_type_name,
                                                  readonly: ""
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "meta-info-overlay"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(work.rate) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.getUnitByCode(
                                                          work.unit_code
                                                        ).shortName
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-group",
                                        { attrs: { label: "Кол-во" } },
                                        [
                                          work.unit_code === "539"
                                            ? _c("b-form-input", {
                                                attrs: {
                                                  value: _vm.calculatedHours,
                                                  disabled: ""
                                                }
                                              })
                                            : _c("b-form-input", {
                                                attrs: { type: "number" },
                                                model: {
                                                  value:
                                                    _vm.workerItems.total_units,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.workerItems,
                                                      "total_units",
                                                      _vm._n($$v)
                                                    )
                                                  },
                                                  expression:
                                                    "workerItems.total_units"
                                                }
                                              })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }),
                                _vm._v(" "),
                                _vm.locationWorks.length === 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-center text-muted p-2"
                                      },
                                      [
                                        _vm._v(
                                          "\n                Вид работ не выбран\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-tab",
                          { attrs: { title: "Расходы" } },
                          [
                            _c("b-card", { staticClass: "custom-card my-2" }, [
                              _c(
                                "div",
                                { staticClass: "w-100 d-flex flex-column" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: { label: "Обед, ч." }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          type: "number",
                                          step: "0.5",
                                          min: "0"
                                        },
                                        model: {
                                          value: _vm.workerItems.dinner,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.workerItems,
                                              "dinner",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "workerItems.dinner"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-2",
                                      attrs: { label: "Трансфер, ₽" }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: { type: "number", min: "0" },
                                        model: {
                                          value: _vm.workerItems.road_price,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.workerItems,
                                              "road_price",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "workerItems.road_price"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    { attrs: { label: "Аванс, ₽" } },
                                    [
                                      _c("b-form-input", {
                                        attrs: { type: "number", min: "0" },
                                        model: {
                                          value: _vm.workerItems.prepaid,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.workerItems,
                                              "prepaid",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "workerItems.prepaid"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-tab",
                          { attrs: { title: "Услуги" } },
                          [
                            _vm._l(
                              _vm.workerItems.task_worker_services,
                              function(service, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "custom-card my-2 p-2"
                                  },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        staticClass: "mb-2",
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function() {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex align-items-center justify-content-between"
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v("Вид услуги")
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-button",
                                                        {
                                                          staticClass:
                                                            "p-0 text-danger",
                                                          attrs: {
                                                            variant: "link"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.removeService(
                                                                index
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("v-icon", {
                                                            attrs: {
                                                              name:
                                                                "buttons/trash",
                                                              size: 14
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("b-form-select", {
                                          attrs: {
                                            options: _vm.services,
                                            size: "sm"
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.onServiceSelected(
                                                $event,
                                                index
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "first",
                                                fn: function() {
                                                  return [
                                                    _c(
                                                      "b-form-select-option",
                                                      {
                                                        attrs: {
                                                          value: null,
                                                          disabled: ""
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Выберите услугу"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                },
                                                proxy: true
                                              }
                                            ],
                                            null,
                                            true
                                          ),
                                          model: {
                                            value:
                                              service.location_work_service_id,
                                            callback: function($$v) {
                                              _vm.$set(
                                                service,
                                                "location_work_service_id",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "service.location_work_service_id"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "row no-gutters" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "col-6 pr-1" },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                staticClass: "mb-0",
                                                attrs: { label: "Кол-во" }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    value: service.quantity,
                                                    type: "number",
                                                    size: "sm"
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      return _vm.onServiceQuantityInput(
                                                        index,
                                                        $event
                                                      )
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-6 pl-1 d-flex flex-column justify-content-end"
                                          },
                                          [
                                            service.location_work_service_id
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-right pb-1"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "font-size":
                                                            "0.75rem",
                                                          "line-height": "1"
                                                        }
                                                      },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            "Итого: " +
                                                              _vm._s(
                                                                service.total_price
                                                              ) +
                                                              " ₽"
                                                          )
                                                        ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-muted mt-2",
                                                        staticStyle: {
                                                          "font-size":
                                                            "0.75rem",
                                                          "line-height": "1"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      Цена: " +
                                                            _vm._s(
                                                              service.price
                                                            ) +
                                                            " ₽ / " +
                                                            _vm._s(
                                                              _vm.getUnitByCode(
                                                                service.unit_code
                                                              ).shortName
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              }
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "mt-2 custom-btn-dashed",
                                attrs: { block: "" },
                                on: { click: _vm.addService }
                              },
                              [
                                _c("v-icon", {
                                  attrs: { name: "buttons/plus", size: 11 }
                                }),
                                _vm._v(
                                  "\n              Добавить услугу\n            "
                                )
                              ],
                              1
                            )
                          ],
                          2
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-center flex-shrink-0"
                      },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "custom-btn-secondary mr-2",
                            on: { click: _vm.cancelPlanning }
                          },
                          [_vm._v("Закрыть")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            staticClass: "custom-btn-primary",
                            on: { click: _vm.savePlaningData }
                          },
                          [_vm._v("Применить")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.activePopover.targetId
        ? _c(
            "b-popover",
            {
              attrs: {
                target: _vm.activePopover.targetId,
                show: _vm.activePopover.show,
                boundary: "window",
                placement: "bottom",
                triggers: "manual",
                container: "body",
                "custom-class": "timesheet-popover"
              },
              on: {
                "update:show": function($event) {
                  return _vm.$set(_vm.activePopover, "show", $event)
                },
                shown: _vm.addOutsideClickListener,
                hidden: _vm.removeOutsideClickListener
              }
            },
            [
              _c(
                "button",
                {
                  staticClass: "close",
                  staticStyle: {
                    position: "absolute",
                    top: "-3px",
                    right: "0",
                    "font-size": "1.2rem",
                    "line-height": "1",
                    outline: "none"
                  },
                  attrs: { type: "button", "aria-label": "Close" },
                  on: {
                    click: function($event) {
                      _vm.activePopover.show = false
                    }
                  }
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("×")
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.popoverDetails
                ? _c(
                    "div",
                    { staticClass: "text-small mx-1" },
                    [
                      _vm.popoverDetails.isPlanned
                        ? [
                            _c("div", { staticClass: "mb-1" }, [
                              _vm._v(
                                "Дата и время начала: " +
                                  _vm._s(_vm.popoverDetails.startStr) +
                                  ";"
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "mb-1" }, [
                              _vm._v(
                                "Дата и время окончания: " +
                                  _vm._s(_vm.popoverDetails.endStr) +
                                  ";"
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "mb-1" }, [
                              _vm._v(
                                "Количество работы: " +
                                  _vm._s(_vm.popoverDetails.total_units) +
                                  ";"
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "mb-1" }, [
                              _vm._v(
                                "Ставка: " +
                                  _vm._s(_vm.popoverDetails.price) +
                                  "; Аванс: " +
                                  _vm._s(_vm.popoverDetails.prepaid) +
                                  ";"
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "mb-1" }, [
                              _vm._v(
                                "Обед: " +
                                  _vm._s(_vm.popoverDetails.dinner) +
                                  " час; Трансфер: " +
                                  _vm._s(_vm.popoverDetails.road_price) +
                                  ";"
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "mb-1 font-weight-bold" },
                              [
                                _vm._v(
                                  "Итого: " +
                                    _vm._s(_vm.popoverDetails.total_price) +
                                    ";"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.popoverDetails.servicesStr
                              ? _c("div", { staticClass: "mt-2 text-muted" }, [
                                  _vm._v(
                                    "\n          Услуги исполнителя: " +
                                      _vm._s(_vm.popoverDetails.servicesStr) +
                                      "\n        "
                                  )
                                ])
                              : _vm._e()
                          ]
                        : [
                            _c("div", { staticClass: "text-muted mb-2" }, [
                              _vm._v("Исполнитель ещё не запланирован.")
                            ])
                          ],
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between gap-2 mt-3"
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "custom-btn-primary",
                              on: { click: _vm.editFromPopover }
                            },
                            [_vm._v("\n          Редактировать\n        ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "custom-btn-danger",
                              on: { click: _vm.removeFromPopover }
                            },
                            [_vm._v("\n          Удалить\n        ")]
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          ref: "price_popover",
          attrs: {
            target: "price-target",
            triggers: "click",
            placement: "right",
            "custom-class": "custom-popover"
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function() {
                return [_vm._v("Назначить всем исполнителям")]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "p-1" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Ставка" } },
                [
                  _c("b-input", {
                    attrs: {
                      type: "number",
                      min: 0,
                      placeholder: "Введите сумму"
                    },
                    model: {
                      value: _vm.allWorkersPrice,
                      callback: function($$v) {
                        _vm.allWorkersPrice = _vm._n($$v)
                      },
                      expression: "allWorkersPrice"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex justify-content-end mt-2" }, [
                _c(
                  "button",
                  {
                    staticClass: "custom-btn-primary",
                    on: { click: _vm.applyWorkersPrice }
                  },
                  [_vm._v("\n          Применить\n        ")]
                )
              ])
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "timesheet-header-fixed" }, [
      _c("div", { staticClass: "timesheet-row mb-1" }, [
        _c("div", { staticClass: "worker-col-spacer" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "timesheet-row" }, [
        _c("div", { staticClass: "worker-col-header text-muted" }, [
          _vm._v("Исполнители")
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "price-col-header text-muted",
            staticStyle: { cursor: "pointer" },
            attrs: { id: "price-target" }
          },
          [_vm._v("Ставка")]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50dffc68", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50dffc68","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tasks/TaskTimesheet.vue
// module id = null
// module chunks = 